import portfolio from '../data/portfolio'

export default {
  portfolio,
}